import { motion } from 'framer-motion';
import { menuCategories } from '../data/menuData';
import { MenuItemCard } from '../components/MenuItemCard';

const newItems = [
  menuCategories[1].items[3],
  menuCategories[2].items[4],
  menuCategories[3].items[1]
];

export default function NewAdditions() {
  return (
    <div className="min-h-screen py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <span className="inline-block bg-turmeric text-brown-dark px-6 py-2 rounded-full font-bold text-sm mb-4">
            NEW
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-playfair font-bold text-brown-dark mb-4">
            New Additions
          </h1>
          <p className="text-lg text-brown-medium max-w-2xl mx-auto">
            Discover our latest gourmet creations
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {newItems.map((item, index) => (
            <MenuItemCard key={item.id} item={item} index={index} />
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16 text-center bg-cream-accent/50 rounded-2xl p-8"
        >
          <p className="text-xl font-caveat text-brown-dark mb-4">
            More delicious surprises coming soon!
          </p>
          <a
            href="/menu"
            className="inline-block bg-leaf text-white px-8 py-3 rounded-full hover:bg-leaf-hover transition-all transform hover:-translate-y-1 font-bold"
            data-testid="view-menu-btn"
          >
            Explore Full Menu
          </a>
        </motion.div>
      </div>
    </div>
  );
}